import * as yup from 'yup';

import { publicDonationResultSchema } from '@/core/types/donation';
import { adminResultSchema, cityResultSchema, countryResultSchema, subResultSchema } from '@/core/types/geo';
import { userResultSchema } from '@/core/types/users';

export enum ContactType {
  FOLLOW = 1,
  BLOCK = 2,
}

export const usersContactFormSchema = yup.object({
  type: yup
    .mixed<ContactType>()
    .oneOf(Object.values(ContactType) as number[])
    .required(),
  note: yup.string().optional(),
});

export type UsersContactForm = yup.InferType<typeof usersContactFormSchema>;

export const usersContactResultSchema = yup.object({
  user: yup.string().required(),
  for_user: yup.string().required(),
  type: yup.number().required(),
  note: yup.string().nullable(),
  created_at: yup.string().required(),
  updated_at: yup.string().required(),
});

export type UsersContactResult = yup.InferType<typeof usersContactResultSchema>;

export const usersContactsResultSchema = yup.object({
  total: yup.number().required(),
  contacts: yup.array(usersContactResultSchema).required(),
  users: yup.array(userResultSchema).required(),
});
export type UsersContactsResult = yup.InferType<typeof usersContactsResultSchema>;

// Contacts follows
export const usersContactFollowsResultSchema = yup.object({
  created_at: yup.string().required(),
  donations: yup.number().required(),
  user: yup.string().required(),
  updated_at: yup.string().required(),
});
export type UsersContactFollowsResult = yup.InferType<typeof usersContactFollowsResultSchema>;
export const usersContactsFollowsResultSchema = yup.object({
  total: yup.number().required(),
  follows: yup.array(usersContactFollowsResultSchema).required(),
  users: yup.array(userResultSchema).required(),
});
export type UsersContactsFollowsResult = yup.InferType<typeof usersContactsFollowsResultSchema>;

// Contacts Donations
export const contactsDonationsResultSchema = yup.object({
  hash: yup.string().nullable(),
  total: yup.number().required(),
  took: yup.number().required(),

  donations: yup.array(publicDonationResultSchema).required(),
  countries: yup.array(countryResultSchema.required()).nullable(),
  admins: yup.array(adminResultSchema.required()).nullable(),
  cities: yup.array(cityResultSchema.required()).nullable(),
  subs: yup.array(subResultSchema.required()).nullable(),
  users: yup.array(userResultSchema).required(),
});
export type ContactsDonationsResult = yup.InferType<typeof contactsDonationsResultSchema>;
